import { Component, Input } from '@angular/core';

import { ResponseModel } from '../../models/responseModel';
import { LinkTypeEnumeration } from '../models/responseModel';
import { KnowledgeBaseOwiService } from '../services/knowledge-base-OWI.service';

@Component({
  selector: 'knowledge-base-response-models-accordion',
  templateUrl: 'knowledge-base-response-models-accordion.component.html',
  styleUrls: ['./knowledge-base-response-models-accordion.component.scss'],
})
export class KnowledgeBaseResponseModelsAccordionComponent {
  @Input() readonly responseModels: ResponseModel[];
  @Input() readonly canCopyPaste: boolean;
  @Input() readonly expanded: boolean;
  @Input() readonly multi: boolean;
  readonly LinkTypeEnumeration = LinkTypeEnumeration;

  constructor(private readonly knowledgeBaseOwiService: KnowledgeBaseOwiService) {}

  copyPaste(responseModel: ResponseModel, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.knowledgeBaseOwiService.copyPaste(responseModel);
  }
}
